export default __webpack_public_path__ + "static/lokalizacja_bg-6b01de8f05906c4844a7d098249f1181.png";